module.exports = __webpack_public_path__ + "static/media/averaged_trajectories_mislabeled.f16b9d8d.png";